import { render } from "./InstructorAccessRequest.vue?vue&type=template&id=1a0635d8&scoped=true"
import script from "./InstructorAccessRequest.vue?vue&type=script&lang=js"
export * from "./InstructorAccessRequest.vue?vue&type=script&lang=js"

import "./InstructorAccessRequest.vue?vue&type=style&index=0&id=1a0635d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0635d8"]])

export default __exports__